<div [formGroup]="formGroup.form">
  <z-popup-lov
    [fieldName]="fieldName"
    [enableDropdown]="false"
    [label]="label"
    [placeholder]="placeholder"
    [buttonAction]="openDialog"
    [hint]="hint"
    [readonly]="readonly"
    [disabled]="disabled"
    [uppercase]="uppercase"
    [clearButton]="clearButton"
    [manualInput]="manualInput"
    [showDropdownFilter]="showDropdownFilter"
    [doubleClickToOpenPopup]="doubleClickToOpenPopup"
    [matchTypes]="matchTypes"
    [defaultMatchType]="defaultMatchType"
    (matchTypeChange)="onMatchTypeChange($event)"
    (change)="onChangeHandler($event)"
    (clear)="onClearHandler($event)"
  >
  </z-popup-lov>
</div>
